export default "__VITE_ASSET__DBXxx4ox__";